export enum SalePercentages {
  NONE = 0,
  TEN = 10,
  FIFTEEN = 15,
  TWENTY = 20,
  TWENTY_FIVE = 25,
  THIRTY = 30,
  THIRTY_FIVE = 35,
  FORTY = 40,
  FORTY_FIVE = 45,
  FIFTY = 50,
}
